var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.customerGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.customerGetErrors = $event
          }
        }
      }),
      _c("v-data-table", {
        attrs: {
          items: _vm.customerList,
          headers: _vm.headers,
          dense: "",
          loading: _vm.customerGetting,
          "server-items-length": _vm.serverItemsLength,
          "single-expand": "",
          page: _vm.page,
          "items-per-page": _vm.itemsPerPage
        },
        on: {
          "update:page": function($event) {
            _vm.page = $event
          },
          "update:itemsPerPage": function($event) {
            _vm.itemsPerPage = $event
          },
          "update:items-per-page": function($event) {
            _vm.itemsPerPage = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: _vm.headers.length } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "search",
                          "append-icon": "mdi-magnify"
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item, expand, isExpanded }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.id))]),
                  _c("td", [_vm._v(_vm._s(_vm.$autoAbbriviate(item.company)))]),
                  _c("td", [_vm._v(_vm._s(item.invoices_count))]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          class: isExpanded ? "is-expanded" : "",
                          attrs: {
                            text: "",
                            small: "",
                            color: "blue-grey darken-3"
                          },
                          on: {
                            click: function($event) {
                              return expand(!isExpanded)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-chevron-down")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: "4" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "text-left grey--text",
                              attrs: { cols: "3" }
                            },
                            [
                              _c("small", { staticClass: "text-uppercase" }, [
                                _vm._v("Stock")
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "text-center grey--text",
                              attrs: { cols: "3" }
                            },
                            [
                              _c("small", { staticClass: "text-uppercase" }, [
                                _vm._v("Quantity")
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "text-right grey--text",
                              attrs: { cols: "3" }
                            },
                            [
                              _c("small", { staticClass: "text-uppercase" }, [
                                _vm._v("Amount")
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _vm._l(item.order_details, function(detail, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            _c(
                              "v-row",
                              { attrs: { justify: "center" } },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass:
                                      "text-left blue-grey--text darken-4",
                                    attrs: { cols: "3" }
                                  },
                                  [
                                    _c("div", [
                                      _c("small", [
                                        _vm._v(_vm._s(detail.stock.description))
                                      ])
                                    ])
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "blue-grey--text darken-4",
                                    attrs: { cols: "3" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-right pr-2" },
                                      [
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(_vm.getQuantity(detail))
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass:
                                      "text-right blue-grey--text darken-4",
                                    attrs: { cols: "3" }
                                  },
                                  [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s((detail.amount || 0).phpFormat())
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _c("v-divider")
                          ],
                          1
                        )
                      }),
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "text-right grey--text",
                              attrs: { cols: "6" }
                            },
                            [
                              _c("div", { staticClass: "pr-2" }, [
                                _c("small", { staticClass: "text-uppercase" }, [
                                  _vm._v("Total")
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "text-right blue-grey--text",
                              attrs: { cols: "3" }
                            },
                            [
                              _c("small", [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .calculateSumOfAmount(item.order_details)
                                      .phpFormat()
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }